<template lang="pug">
  .reply(v-if="to" :class="{ reverse }" @click="$emit('click')")
    Icon(name="reference")
    .answer(v-if="reverse") Ответ
    .name {{ authorName }}
    Icon.remove(name="close" v-if="removable" @click.native.stop="$emit('remove')" pointer)
</template>

<script>
import utils from '@/utils/common';

export default {
  name: 'CommentReplyTile',
  props: {
    to: Object,
    reverse: Boolean,
    removable: Boolean,
  },
  computed: {
    authorName() { return utils.getUserName(this.to.author); },
  },
};
</script>

<style scoped lang="scss">
.reply {
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;

  &.reverse svg {
    transform: rotate(180deg);
  }

  .answer {
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: #788CA1;
  }

  .name {
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.01em;
  }

  .date {
    font-size: 12px;
    color: var(--color-middle-gray)
  }

  .remove {
    fill: var(--color-middle-gray)
  }

  // todo...
  .author-is-user {
    width: 17px;
    height: 17px;
    background: #FFE0CC;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
  }
}

</style>
